<header-component *ngIf="template === 'mobile'" [color]="backgroundColor" [title]="'NAVIGATION.CALENDAR' | translate"></header-component>
<ion-content>
    <calendar-mobile-page *ngIf="template === 'mobile'"></calendar-mobile-page>
	<calendar-desktop-page *ngIf="template === 'desktop'"></calendar-desktop-page>
</ion-content>